export default "/images/9eac8e6db8110bd6a16206806168cb5b.png";